const DEFAULT_STATE = {
  dates: [],
  metrics: [],
  utms: [],
  platforms: [],
  sites: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getDates: (state) => state.dates,
    getMetrics: (state) => state.metrics,
    getUtms: (state) => state.utms,
    getPlatforms: (state) => state.platforms,
    getSites: (state) => state.sites,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setMetrics(state, payload) {
      state.metrics = payload;
    },
    setUtms(state, payload) {
      state.utms = payload;
    },
    setPlatforms(state, payload) {
      state.platforms = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
    async updateFilteredMetrics({ state }, platformId) {
      return state.metrics.filter(
        (metric) => metric.acqui_platform_id === parseInt(platformId, 10)
      );
    },
    async updateFilteredUtms({ state }, platformId) {
      return state.utms.filter(
        (utm) => utm.acqui_platform_id === parseInt(platformId, 10)
      );
    },
    updatePlatforms({ commit }, payload) {
      commit("setPlatforms", payload);
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
  },
};
